import request from './request';

const helperSetOptions = (options) => {
  if (!options || typeof options !== 'object') {
    return '';
  }

  let urlOptions = '';
  Object.keys(options).forEach((key) => {
    if (options[key] && options[key].length > 0) {
      if (key === 'wines') {
        urlOptions += `${urlOptions ? '&' : '?'}${key}=["${options[key]}"]`;
      } else {
        urlOptions += `${urlOptions ? '&' : '?'}${key}=${options[key]}`;
      }
    }
  });
  return urlOptions;
};

export const fetchAuction = (options) =>
  request({
    method: 'GET',
    url: `/api/v1/clients/me/vae/data/${helperSetOptions(options)}`,
    protectedRoute: true,
    newApi: false
  });
